import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IPermissionProps } from "../../models/Login";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { IModal } from "./ClientTransferSetting";

export interface IClientTransferSetting{
    setting_ID?: number,
    setting_Head?: string,
    number?: number | null,
    weightage?: number | null,
    setting_Status?: boolean,
    createdBy?: number | null,
    createdOn?: Date | null,
}

export const EmptyClientTransferSetting = {
    setting_Head: "",
    number: null,
    weightage: null,
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const Table = (props: Iprops) => {
    const [tableData,setTableData] = useState({tableData: [], loading: false} as {tableData: IClientTransferSetting[], loading: boolean});
    const dt = useRef<any>(null);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Client Transfer Setting</h5>
        </div>
    );

    const openNew=()=>{
        props.setModal({ open: true, singleData: EmptyClientTransferSetting });
    };
    const openEdit=(rowData: IClientTransferSetting)=>{
        props.setModal({ open: true, singleData: rowData });
    };

    const action=(rowData: IClientTransferSetting)=>{
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={()=>openEdit(rowData)}></Button>
            </div>
        );
    }

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>: ''
        );
    };

    const loadTableData = async ()=>{
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("tbl_Client_Transfer_Setting", "GET", null, null, props.toast);
        if(response){
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '3rem' }} />
                <Column field="setting_Head" header="Head Name"/>
                <Column field="number" header="Number" />
                <Column field="weightage" header="Weightage" />
                {props.permissions.is_Update && <Column field="" header="Action" body={action} />}
            </DataTable>
        </>
    );
}